import { Directive } from '@angular/core';
import { NG_VALIDATORS, Validator, AbstractControl } from '@angular/forms';
import { alphabeticValidator } from '../validatorFunctions';

@Directive({
  selector: '[gtAlphabeticValidator]',
  providers: [{provide: NG_VALIDATORS, useExisting: AlphabeticValidatorDirective, multi: true}]
})
export class AlphabeticValidatorDirective implements Validator {

  validate(control: AbstractControl): {[key: string]: any} | null {
    return alphabeticValidator()(control);
  }
}
